<template>
  <div class="convert-price" :style="styles">
  <svg-icon iconClass="shell" :size="iconSize" v-if="showIcon"></svg-icon>
    <!-- <span v-if="insignia" > </span> -->
    <span>{{ convertPrice }}</span>
  </div>
</template>
<script>
export default {
  props: {
    iconSize:{
      type: String,
      default: '18'
    },
    styles: {
      type: Object,
      default: () => ({})
    },
    price: {
      type: [Number, String]
    },
    showIcon: { // 展示icon
      type: Boolean,
      default: true
    },
    insignia: { // 展示符号
      type: Boolean,
      default: true
    }
  },
  computed: {
    convertPrice () {
      return  this.price
      // return this.price.toLocaleString('vi-VN')
    }
  }
}
</script>
<style lang="scss" scoped>
  .convert-price{
    @include flex($justify: start);
    width: fit-content;
    span{
      margin-left: 0.05rem;
      // display: inline-block;
    }
  }
</style>